import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysFinanceIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [
      snapshot,
      recommendation,
      dataSourceInfo,
      employerContributions,
      loansData,
      section127Info,
    ] = await Promise.all([
      this.reimaginedData.fetchFinancialSnapshot(),
      this.reimaginedData.fetchSection127Recommendation(),
      this.reimaginedData.getDataSourceInfo(),
      this.reimaginedData.fetchEmployerContributions(),
      this.reimaginedData.fetchLoansData(),
      this.reimaginedData.fetchSection127Info(),
    ]);

    return {
      snapshot,
      recommendation,
      dataSourceInfo,
      employerContributions,
      loansData,
      section127Info,
    };
  }
}
